import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  getEnvelopeSenderList,
  deleteFilesKeywords,
  searchKeywordMyfiles,
  myFilesDetailsForm,
  myFilesPreviewDetailsForm,
  myFilesFolderView
} from "../../../../services/CommonService";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../utils";
import { FaTimes, } from "react-icons/fa";
import { toast } from "react-toastify";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import useDocumentCounts from "./useDocumentCounts";
import DocumentForm from "./Files/DocumentForm";
import { commonFields, documentFields } from "./Files/DocumentForm";
import { Button, Spinner, Modal } from "react-bootstrap";
import Pagination from "react-js-pagination";
import mammoth from "mammoth";
import MyFilesFolder from "./MyFilesFolder";
import { CiGrid41 } from "react-icons/ci";
import { CiBoxList } from "react-icons/ci";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';

import ReminderModal from './ViewMyFiles/ReminderModal';
import MyFilesMetadata from "./ViewMyFiles/MyFilesMetadata";
import MyFilesTag from './ViewMyFiles/MyFilesTag';
import ShareDocumentModal from "./ViewMyFiles/ShareDocumentModal";
import DeleteFilesModal from "./ViewMyFiles/DeleteFilesModal";

const MyFiles = () => {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [dataParams, setDataParams] = useState({ limit: 10, page: 1 });
  const [files, setFiles] = useState([]);
  const [fetchedFiles, setFetchedFiles] = useState([]);
  const [allFiles, setAllFiles] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [senderList, setSenderList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedDocForPreview, setSelectedDocForPreview] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [searchText, setSearchText] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [showSherModal, setShowSherModal] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [formOffcanvasOpen, setFormOffcanvasOpen] = useState(false);
  const [detailsOffcanvasOpen, setDetailsOffcanvasOpen] = useState(false);
  const [selectedFormDoc, setSelectedFormDoc] = useState(null);
  const [formData, setFormData] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [documentType, setDocumentType] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [storedFileId, setStoredFileId] = useState(null);
  const [viewMode, setViewMode] = useState('folder');
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [showMetadataModal, setShowMetadataModal] = useState(false);
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [selectedReminderFile, setSelectedReminderFile] = useState(null);
  const [reminderStatus, setReminderStatus] = useState({});
  const [textContent, setTextContent] = useState(null);

  const handleViewChange = (e) => {
    setLoading(true);
    setViewMode(e.target.value);
  };

  const lengths = Utils.tableShowLengths();

  const {
    counts: {
      totalMyFile,
      totalInProgress,
      totalDraft,
      totalCompleted,
    },
    loading,
    setLoading,
  } = useDocumentCounts({ userEmail, selectedUserId, dataParams });

  const paginatedFiles = fetchedFiles.slice(
    (dataParams.page - 1) * dataParams.limit,
    dataParams.page * dataParams.limit
  );

  const handleData = (e, type) => {
    let params = { ...dataParams };
    if (type === "pagination") {
      params.page = e;
    } else if (type === "limit") {
      params.limit = parseInt(e.target.value);
      params.page = 1;
    }
    setDataParams(params);
  };

  useEffect(() => {
    getEnvelopeSenderList()
      .then((response) => {
        const senderData = response.data.data;
        setSenderList(senderData);
        if (senderData.length > 0) setSelectedUserId(Number(senderData[0].id));
      })
      .catch((err) => console.error("Failed to fetch sender list", err));
  }, []);

  useEffect(() => {
    if (selectedUserId) fetchFiles([], dataParams.page, dataParams.limit);
  }, [selectedUserId, dataParams.limit]);

  const isAllSelected = useMemo(() => {
    return (
      selectedFiles.length === paginatedFiles.length &&
      paginatedFiles.length > 0
    );
  }, [selectedFiles, paginatedFiles]);

  useEffect(() => {
    setIsSelectAll(isAllSelected);
  }, [isAllSelected]);

  const normalizeKeywords = (keywords) => {
    if (!keywords) return "";
    if (Array.isArray(keywords)) return keywords.join(", ");
    if (typeof keywords === "string") return keywords;
    return "";
  };

  const fetchFiles = async (
    searchQueries = [],
    page = dataParams.page,
    limit = dataParams.limit
  ) => {
    if (!selectedUserId) return;
    setLoading(true);

    try {
      if (searchQueries.length === 0) {
        const response = await myFilesFolderView({
          user_id: selectedUserId,
          view_type: viewMode === "folder" ? "folder_view" : "all_files",
          page,
          limit
        });

        const filesData = (response?.data?.data?.files || []).map((file) => ({
          id: file.file_id || file.id,
          file_name: file.name || file.file_name,
          file_size: file.size || file.file_size,
          document_type:
            (file.doc_type || file.document_type) === "N/A"
              ? null
              : file.doc_type || file.document_type || null,
          keywords: normalizeKeywords(file.tags || file.tag || file.keywords),
          upload_date: file.created_at || file.upload_date,
          file_path: file.file_path || file.url || file.file_url || "",
          hasDetails: false,
          metadata: file.metadata || {},
          reminder: file.reminder || null,
        }));

        setAllFiles(filesData);
        setFetchedFiles(filesData);
        setTotalDocuments(response.data.total_file_count || filesData.length);

      } else {
        const searchResults = await searchKeywordMyfiles({
          user_id: selectedUserId,
          keyword: searchQueries.join(","),
          page,
          limit,
        });

        const searchedFiles = (searchResults?.data?.data || []).map((file) => ({
          id: file.file_id || file.id,
          file_name: file.name || file.file_name,
          file_size: file.size || file.file_size,
          document_type:
            (file.doc_type || file.document_type) === "N/A"
              ? null
              : file.doc_type || file.document_type || null,
          keywords: normalizeKeywords(file.tags || file.tag || file.keywords),
          upload_date: file.created_at || file.upload_date,
          file_path: file.file_path || file.url || file.file_url || "",
          hasDetails: false,
          metadata: file.metadata || {},
          reminder: file.reminder || null,
        }));

        setFetchedFiles(searchedFiles);
        setTotalDocuments(searchResults.data.total || searchedFiles.length);
      }
    } catch (error) {
      console.error("Error fetching files:", error);
      setFetchedFiles([]);
      setTotalDocuments(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedUserId) fetchFiles([], dataParams.page, dataParams.limit);
  }, [selectedUserId, dataParams.limit, dataParams.page, viewMode]);

  useEffect(() => {
    if (fetchedFiles.length === 0) return;

    const updatedFiles = fetchedFiles.map((file) => {
      const persistedData = localStorage.getItem(`formDetails_${file.id}`);
      return persistedData ? { ...file, ...JSON.parse(persistedData) } : file;
    });

    if (JSON.stringify(updatedFiles) !== JSON.stringify(fetchedFiles)) {
      setFetchedFiles(updatedFiles);
      setAllFiles(updatedFiles);
    }
  }, [fetchedFiles]);

  const handleOpenDetailsOffcanvas = async (file, fileId = null) => {
    setSelectedFormDoc(file);
    const effectiveFileId = fileId || storedFileId || file.id;
    setStoredFileId(effectiveFileId);

    setLoading(true);
    try {
      const response = await myFilesPreviewDetailsForm({
        file_id: effectiveFileId,
      });
      const details = response.data?.data || {};

      const filteredDetails = {};
      commonFields.forEach((field) => {
        if (details[field.name] && details[field.name] !== "") {
          filteredDetails[field.name] = details[field.name];
        }
      });

      setFormDetails({
        ...filteredDetails,
        document_type: details.document_type || file.document_type,
        additional_data: details.additional_data || file.additional_data || {},
      });
      setFetchedFiles((prev) =>
        prev.map((f) =>
          f.id === effectiveFileId ? { ...f, hasDetails: true } : f
        )
      );
      setDetailsOffcanvasOpen(true);
    } catch (error) {
      console.warn("Error fetching details:", error.message);
      toast.error(`Failed to load details: ${error.message}`);

      const persistedData = localStorage.getItem(
        `formDetails_${effectiveFileId}`
      );
      if (persistedData) {
        const parsedData = JSON.parse(persistedData);
        setFormDetails({
          ...parsedData,
          document_type: file.document_type,
          additional_data: parsedData.additional_data || {},
        });
        setDetailsOffcanvasOpen(true);
      } else {
        const filteredDetails = {};
        commonFields.forEach((field) => {
          if (file[field.name] && file[field.name] !== "") {
            filteredDetails[field.name] = file[field.name];
          }
        });

        setFormDetails({
          ...filteredDetails,
          document_type: file.document_type,
          additional_data: file.additional_data || {},
        });
        setDetailsOffcanvasOpen(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseFormOffcanvas = () => {
    setFormOffcanvasOpen(false);
    setSelectedFormDoc(null);
    setDocumentType("");
    setFormData({});
  };

  const handleCloseDetailsOffcanvas = () => {
    setDetailsOffcanvasOpen(false);
    setSelectedFormDoc(null);
    setFormDetails({});
  };

  const handleSubmitForm = async (finalFormData) => {
    if (!storedFileId) {
      toast.error("No document selected for saving.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const cleanedFormData = {};
      Object.entries(finalFormData).forEach(([key, value]) => {
        if (key !== "additional_data" && value && value.trim() !== "") {
          cleanedFormData[key] = value.trim();
        }
      });

      const payload = {
        file_id: storedFileId,
        ...cleanedFormData,
        additional_data: finalFormData.additional_data || {},
      };

      const response = await myFilesDetailsForm(payload);
      toast.success("Details saved successfully!");

      setFetchedFiles((prev) =>
        prev.map((file) =>
          file.id === storedFileId
            ? {
              ...file,
              ...cleanedFormData,
              additional_data: finalFormData.additional_data,
              hasDetails: true,
            }
            : file
        )
      );
      setAllFiles((prev) =>
        prev.map((file) =>
          file.id === storedFileId
            ? {
              ...file,
              ...cleanedFormData,
              additional_data: finalFormData.additional_data,
              hasDetails: true,
            }
            : file
        )
      );

      localStorage.setItem(
        `formDetails_${storedFileId}`,
        JSON.stringify({
          ...cleanedFormData,
          additional_data: finalFormData.additional_data,
          hasDetails: true,
        })
      );

      handleCloseFormOffcanvas();
      handleOpenDetailsOffcanvas(
        {
          ...selectedFormDoc,
          ...cleanedFormData,
          additional_data: finalFormData.additional_data,
        },
        storedFileId
      );
    } catch (error) {
      console.error(
        "Error saving form details:",
        error.response?.data || error.message
      );
      toast.error(
        `Failed to save details: ${error.response?.data?.message || error.message}`
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFileManagerOpen = () => fileInputRef.current?.click();

  const openSummaryForFile = (file) => {
    if (!file || !file.file_path) {
      toast.error("Missing document or user ID.");
      return;
    }
    const summaryData = {
      fileId: file.id,
      userId: selectedUserId,
      filePath: file.file_path,
      fileName: file.file_name,
    };
    sessionStorage.setItem("summaryData", JSON.stringify(summaryData));
    const randomId = Math.floor(Math.random() * 1000000);
    const summaryUrl = `/manage/my-files/summary/${randomId}`;
    navigate(summaryUrl);
  };

  const highlightText = (text, searchTerms) => {
    if (text === null || text === undefined) return "N/A";
    const textStr = String(text);

    const allSearchTerms = [
      ...(searchText
        ? searchText
          .map((t) => t.trim())
          .filter((t) => t)
        : []),
      ...(inputValue.trim() ? [inputValue.trim()] : [])
    ].filter((term) => term);

    if (allSearchTerms.length === 0) return textStr;

    const regex = new RegExp(
      `(${allSearchTerms
        .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("|")})`,
      "gi"
    );

    return textStr.split(regex).map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "#FFD700",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handleOpenReminderModal = (file) => {
    const latestFile = fetchedFiles.find(f => f.id === file.id) || file;
    setSelectedReminderFile(latestFile);
    setShowReminderModal(true);
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(
        window.innerWidth <= 768 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      );
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (
      selectedDocForPreview &&
      [".txt", ".csv", ".md", ".log"].some(ext =>
        selectedDocForPreview.file_name?.toLowerCase().endsWith(ext)
      )
    ) {
      setTextContent("Loading...");
      fetch(selectedDocForPreview.file_path)
        .then(res => res.text())
        .then(setTextContent)
        .catch(() => setTextContent("Failed to load text file."));
    } else {
      setTextContent(null);
    }
  }, [selectedDocForPreview]);

  return (
    <>
      <section className="section-bg-color min-height-sleeve sleeve-spacing wrapper-sleeve">
        <div className="custom_container">
          <div className="table_header_wrap">
            <div
              className="nav nav-tabs pb-0 wrap_left flexWrap"
              id="nav-tab"
              role="tablist"
            >
              <button
                className="nav-link mb-3"
                onClick={() => navigate("/manage")}
                type="button"
                role="tab"
              >
                In Progress <span>({totalInProgress})</span>
              </button>
              <button
                className="nav-link mb-3"
                onClick={() => navigate("/manage/draft")}
                type="button"
                role="tab"
              >
                Draft <span>({totalDraft})</span>
              </button>
              <button
                className="nav-link mb-3"
                onClick={() => navigate("/manage/completed")}
                type="button"
                role="tab"
              >
                Completed <span>({totalCompleted})</span>
              </button>
              <button
                className="nav-link mb-3 d-flex"
                onClick={() => navigate("/manage/files")}
                type="button"
                role="tab"
              >
                Sleeves Files
              </button>
              <button
                className="nav-link mb-3 active d-flex"
                onClick={() => navigate("/manage/my-files")}
                type="button"
                role="tab"
              >
                My Files <span></span>
              </button>
            </div>
            <div
              className="d-flex align-items-center bg-light rounded-2 border p-1 mb-3"
              style={{ width: "fit-content" }}
            >
              <button
                className={`btn d-flex align-items-center justify-content-center rounded-2 px-2 py-1 border-0 ${viewMode === "folder"
                  ? "bg-white text-dark shadow-sm"
                  : "bg-transparent text-primary"
                  }`}
                onClick={() =>
                  handleViewChange({ target: { value: "folder" } })
                }
                title="Folder View"
                style={{ minWidth: "35px", height: "35px" }}
              >
                <CiGrid41 size={20} />
              </button>
              <button
                className={`btn d-flex align-items-center justify-content-center rounded-2 px-2 py-1 border-0 ${viewMode === "table"
                  ? "bg-white text-dark shadow-sm"
                  : "bg-transparent text-primary"
                  }`}
                onClick={() => handleViewChange({ target: { value: "table" } })}
                title="Table View"
                style={{ minWidth: "35px", height: "35px" }}
              >
                {loading ? (
                  <div className="page-loading">
                    <img src="/images/loader.gif" alt="loader" />
                  </div>
                ) : (
                  <CiBoxList size={20} />
                )}
              </button>
            </div>
          </div>
          {viewMode === "table" ? (
            <>
              <div>
                <div className="myfiles-tab-content position-relative bg-white mb-4 p-4 rounded">
                  <div className="row">
                    <div className="col-md-8 col-12 mx-auto">
                      <div className="input-group position-relative mb-4">
                        <div
                          className="position-relative"
                          style={{ width: "100%", marginInline: "auto" }}
                        >
                          <div className="tags-input-container form-control mb-2 d-flex flex-wrap align-items-center rounded-2">
                            {/* Tags and input for search keywords */}
                            {searchText.map((tag, index) => (
                              <span
                                key={index}
                                className="badge text-white d-flex align-items-center me-2 px-2 py-1 bg-primary"
                              >
                                {tag}
                                <FaTimes
                                  className="cursor-pointer ms-1 text-dark"
                                  onClick={() => {
                                    const newSearchText = searchText.filter((t) => t !== tag);
                                    setSearchText(newSearchText);
                                    fetchFiles(newSearchText, 1, dataParams.limit);
                                  }}
                                />
                              </span>
                            ))}
                            <input
                              type="text"
                              value={inputValue}
                              onChange={e => setInputValue(e.target.value)}
                              onKeyDown={e => {
                                if ((e.key === "Enter" || e.key === ",") && inputValue.trim()) {
                                  const newKeyword = inputValue.trim();
                                  if (!searchText.includes(newKeyword)) {
                                    const newSearchText = [...searchText, newKeyword];
                                    setSearchText(newSearchText);
                                    fetchFiles(newSearchText, 1, dataParams.limit);
                                  }
                                  setInputValue("");
                                  e.preventDefault();
                                }
                              }}
                              placeholder={searchText.length === 0 ? "Search keyword..." : "Add more keywords..."}
                              className="border-0 outline-0 flex-grow-1"
                              style={{
                                minWidth: "150px",
                                borderRadius: "8px",
                                padding: "5px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-12 gap-4">
                      <button
                        onClick={() => setShowSherModal(true)}
                        disabled={!selectedFiles.length}
                        className="btn btn-primary mb-3 float-end ms-3"
                      >
                        Share
                      </button>
                      <button
                        onClick={() => setIsDeleteModalOpen(true)}
                        disabled={!selectedFiles.length}
                        className="btn btn-danger mb-3 float-end"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                  <div>
                    {paginatedFiles.length === 0 ? (
                      <div className="no-documents-placeholder">
                        <p>No documents have been uploaded.</p>
                      </div>
                    ) : (
                      <div
                        style={{
                          overflowX: "auto",
                          width: "100%",
                          scrollbarWidth: "thin",
                        }}
                        className="table-responsive rounded-3 border"
                      >
                        <table className="table table-hover mb-0">
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: "50px", textAlign: "center" }}>
                                <input
                                  type="checkbox"
                                  checked={isSelectAll}
                                  onChange={() => {
                                    if (isSelectAll) {
                                      setSelectedFiles([]);
                                    } else {
                                      setSelectedFiles(
                                        paginatedFiles.map((file) => file.id)
                                      );
                                    }
                                  }}
                                  className="form-check-input cursor-pointer"
                                />
                              </th>
                              <th style={{ width: "150px", padding: "0.4rem 0.5rem" }}>
                                File Name
                              </th>
                              <th style={{ width: "100px", textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                Size
                              </th>
                              <th style={{ width: "160px", textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                Document Type
                              </th>
                              <th style={{ width: "450px", padding: "0.4rem 0.5rem" }}>
                                <div className="d-flex align-items-center">
                                  Keywords
                                  <i
                                    className="bi bi-info-circle ms-2 text-muted cursor-pointer"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Once your documents are processed, AI automatically generates relevant keywords."
                                  />
                                </div>
                              </th>
                              <th style={{ width: "160px", textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                <div className="d-flex align-items-center justify-content-center">
                                  Upload Date
                                  <i
                                    className="bi bi-info-circle ms-2 text-muted cursor-pointer"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="DD/MM/YYYY"
                                  />
                                </div>
                              </th>
                              <th style={{ width: "50px", textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedFiles.map((file) => {
                              const searchTerms = [
                                ...searchText,
                                ...(inputValue.trim() ? [inputValue.trim()] : [])
                              ].filter((t, i, arr) => t && arr.indexOf(t) === i);

                              const fileName = file.file_name || "Unnamed File";
                              const highlightedFileName = highlightText(
                                fileName,
                                searchTerms
                              );

                              return (
                                <tr key={file.id} className="align-middle">
                                  <td style={{ textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                    <input
                                      type="checkbox"
                                      checked={selectedFiles.includes(file.id)}
                                      onChange={() =>
                                        setSelectedFiles((prev) =>
                                          prev.includes(file.id)
                                            ? prev.filter((id) => id !== file.id)
                                            : [...prev, file.id]
                                        )
                                      }
                                      className="form-check-input cursor-pointer"
                                    />
                                  </td>
                                  <td style={{ padding: "0.4rem 0.5rem" }}>
                                    <div
                                      className="text-truncate"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title={fileName}
                                      style={{ maxWidth: "150px" }}
                                    >
                                      <a
                                        href="#!"
                                        className="text-primary text-decoration-none"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setSelectedDocForPreview(file);
                                          setShowDocumentModal(true);
                                        }}
                                      >
                                        {highlightedFileName}
                                      </a>
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                    <span className="text-muted">
                                      {file.file_size
                                        ? `${(file.file_size / 1024).toFixed(2)} MB`
                                        : "N/A"}
                                    </span>
                                  </td>
                                  <td style={{ textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                    <span className="badge bg-light text-dark">
                                      {highlightText(
                                        file.document_type,
                                        searchTerms
                                      )}
                                    </span>
                                  </td>
                                  <td style={{ padding: "0.4rem 0.5rem", maxWidth: "450px" }}>
                                    <div className="d-flex flex-wrap align-items-center gap-1">
                                      {(Array.isArray(file.keywords) ? file.keywords : (typeof file.keywords === 'string' ? file.keywords.split(',').map(k => k.trim()).filter(Boolean) : [])).length > 0 ? (
                                        <>
                                          {(Array.isArray(file.keywords) ? file.keywords : (typeof file.keywords === 'string' ? file.keywords.split(',').map(k => k.trim()).filter(Boolean) : []))
                                            .slice(0, expandedRows[file.id] ? (Array.isArray(file.keywords) ? file.keywords.length : (typeof file.keywords === 'string' ? file.keywords.split(',').map(k => k.trim()).filter(Boolean).length : 0)) : 1)
                                            .map((keyword, idx) => (
                                              <span
                                                key={idx}
                                                className="badge bg-primary text-white me-1 d-flex align-items-center"
                                                style={{ fontSize: '0.92rem', fontWeight: 500, marginBottom: 0, padding: '0.45em 0.9em' }}
                                              >
                                                {highlightText(keyword, searchTerms)}
                                                <FaTimes
                                                  className="cursor-pointer ms-2"
                                                  style={{ fontSize: '0.92rem', color: 'white' }}
                                                  onClick={async (e) => {
                                                    e.stopPropagation();
                                                    try {
                                                      await deleteFilesKeywords({ user_id: selectedUserId, file_id: file.id, keyword });
                                                      fetchFiles();
                                                    } catch (error) {
                                                      // Optionally show a toast or error
                                                    }
                                                  }}
                                                />
                                              </span>
                                            ))}
                                          {(Array.isArray(file.keywords) ? file.keywords : (typeof file.keywords === 'string' ? file.keywords.split(',').map(k => k.trim()).filter(Boolean) : [])).length > 1 && (
                                            <button
                                              className="btn btn-outline-primary btn-sm rounded-pill py-1 px-3 fw-normal"
                                              style={{ fontSize: "0.92rem", borderWidth: "1px", marginBottom: 0, marginLeft: '0.25rem' }}
                                              onClick={() =>
                                                setExpandedRows((prev) => ({
                                                  ...prev,
                                                  [file.id]: !prev[file.id],
                                                }))
                                              }
                                            >
                                              {expandedRows[file.id]
                                                ? "Show Less"
                                                : `Show More+${(Array.isArray(file.keywords) ? file.keywords.length : (typeof file.keywords === 'string' ? file.keywords.split(',').map(k => k.trim()).filter(Boolean).length : 0)) - 1}`}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <span className="text-muted small">No keywords</span>
                                      )}
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                    <span className="text-muted">
                                      {file.upload_date
                                        ? new Date(
                                          file.upload_date
                                        ).toLocaleString("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                        })
                                        : "N/A"}
                                    </span>
                                  </td>
                                  <td style={{ textAlign: "center", padding: "0.4rem 0.5rem" }}>
                                    <Dropdown
                                      trigger={['click']}
                                      overlay={
                                        <Menu className="custom-rc-dropdown-menu">
                                          <MenuItem key="summary" className="custom-rc-dropdown-item">
                                            <span
                                              className="d-flex align-items-center gap-2"
                                              onClick={() => openSummaryForFile(file)}
                                            >
                                              <i className="bi bi-file-text me-1" /> Summary
                                            </span>
                                          </MenuItem>
                                          <MenuItem key="reminder" className="custom-rc-dropdown-item">
                                            <span
                                              className="d-flex align-items-center gap-2"
                                              onClick={() => handleOpenReminderModal(file)}
                                            >
                                              <i className="bi bi-alarm me-1" /> Reminder
                                            </span>
                                          </MenuItem>
                                          <MenuItem key="add-tag" className="custom-rc-dropdown-item">
                                            <MyFilesTag file={file} userId={selectedUserId} fetchFiles={fetchFiles} />
                                          </MenuItem>
                                          {file.hasDetails && (
                                            <MenuItem key="view-details" className="custom-rc-dropdown-item">
                                              <span
                                                className="d-flex align-items-center gap-2"
                                                onClick={() => handleOpenDetailsOffcanvas(file)}
                                              >
                                                <i className="bi bi-info-circle me-1" /> View Details
                                              </span>
                                            </MenuItem>
                                          )}
                                          <MenuItem key="metadata" className="custom-rc-dropdown-item">
                                            <span
                                              className="d-flex align-items-center gap-2"
                                              onClick={() => {
                                                setSelectedMetadata(file.metadata && Object.keys(file.metadata).length > 0 ? file.metadata : null);
                                                setShowMetadataModal(true);
                                              }}
                                            >
                                              <i className="bi bi-info-square me-1" /> Meta data
                                            </span>
                                          </MenuItem>
                                        </Menu>
                                      }
                                      animation="slide-up"
                                    >
                                      <button
                                        className="btn btn-sm btn-link text-dark cur-pointer"
                                        type="button"
                                      >
                                        <i className="bi bi-three-dots-vertical" />
                                      </button>
                                    </Dropdown>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>

                {paginatedFiles.length > dataParams.limit && (
                  <div className="table_footer_wrap">
                    <div className="d-flex align-items-center">
                      <span className="me-2 text-white fw-bolder fs-6">Show</span>
                      <select
                        className="form-select"
                        value={dataParams.limit}
                        onChange={(e) => handleData(e, "limit")}
                        style={{ width: "80px" }}
                      >
                        {lengths.map((item, i) => (
                          <option value={item} key={i}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="pagination">
                      <Pagination
                        activePage={dataParams.page}
                        itemsCountPerPage={dataParams.limit}
                        totalItemsCount={totalDocuments}
                        pageRangeDisplayed={5}
                        onChange={(e) => handleData(e, "pagination")}
                      />
                    </div>
                  </div>
                )}

                <div
                  className={`offcanvas offcanvas-end ${formOffcanvasOpen ? "show" : ""}`}
                  tabIndex="-1"
                  id="formOffcanvas"
                  style={{
                    visibility: formOffcanvasOpen ? "visible" : "hidden",
                    minWidth: "50%",
                  }}
                >
                  <DocumentForm
                    doc={selectedFormDoc}
                    formData={formData}
                    setFormData={setFormData}
                    documentType={documentType}
                    setDocumentType={setDocumentType}
                    onClose={handleCloseFormOffcanvas}
                    commonFields={commonFields}
                    documentFields={documentFields}
                    onSubmit={handleSubmitForm}
                  />
                </div>

                <div
                  className={`offcanvas offcanvas-end ${detailsOffcanvasOpen ? "show" : ""}`}
                  tabIndex="-1"
                  id="detailsOffcanvas"
                  style={{
                    visibility: detailsOffcanvasOpen ? "visible" : "hidden",
                    minWidth: "50%",
                  }}
                >
                  <div className="offcanvas-header">
                    <h5 className="offcanvas-title">
                      Form Details for {selectedFormDoc?.file_name}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => handleCloseDetailsOffcanvas()}
                    ></button>
                  </div>
                  <div className="offcanvas-body">
                    {Object.keys(formDetails).length > 0 ? (
                      <table className="table table-bordered">
                        <thead className="thead-light">
                          <tr>
                            <th scope="col" style={{ width: "40%" }}>
                              Field
                            </th>
                            <th scope="col" style={{ width: "60%" }}>
                              Value
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {commonFields
                            .filter(
                              (field) =>
                                formDetails[field.name] &&
                                formDetails[field.name] !== ""
                            )
                            .map((field) => (
                              <tr key={field.name}>
                                <td>{field.label}</td>
                                <td>
                                  {formDetails[field.name] === null
                                    ? "null"
                                    : formDetails[field.name] || "-"}
                                </td>
                              </tr>
                            ))}
                          {formDetails.additional_data &&
                            Object.entries(formDetails.additional_data)
                              .filter(([key, value]) => value && value !== "")
                              .map(([key, value]) => (
                                <tr key={key}>
                                  <td>
                                    {key
                                      .replace(/_/g, " ")
                                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                                  </td>
                                  <td>{value === null ? "null" : value || "-"}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No details available for this file.</p>
                    )}
                    <div className="modal-footer border-2 border-top py-2">
                      <button
                        className="btn btn-primary me-2"
                        onClick={() => {
                          setFormData({
                            ...formDetails,
                            additional_data: formDetails.additional_data || {},
                          });
                          setStoredFileId(selectedFormDoc.id);
                          handleCloseDetailsOffcanvas();
                          setFormOffcanvasOpen(true);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => handleCloseDetailsOffcanvas()}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>

                <DeleteFilesModal
                  show={isDeleteModalOpen}
                  onHide={() => setIsDeleteModalOpen(false)}
                  selectedFiles={selectedFiles}
                  userId={selectedUserId}
                  fetchFiles={fetchFiles}
                  setSelectedFiles={setSelectedFiles}
                  setIsSelectAll={setIsSelectAll}
                  toast={toast}
                  deleteType="myfiles"
                />

                <Modal
                  show={showDocumentModal}
                  onHide={() => setShowDocumentModal(false)}
                  centered
                  size="xl"
                >
                  <Modal.Header>
                    <Modal.Title>Document Preview</Modal.Title>
                    <button
                      type="button"
                      className="bg-transparent fw-bold"
                      onClick={() => setShowDocumentModal(false)}
                      disabled={loading}
                      aria-label="Close"
                    >
                      <i className="bi bi-x-lg me-2"></i>
                    </button>
                  </Modal.Header>
                  <Modal.Body
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    {(() => {
                      const file = selectedDocForPreview;
                      if (!file) return null;
                      const fileName = file.file_name?.toLowerCase() || "";
                      const fileUrl = file.file_path;
                      // PDF
                      if (fileName.endsWith(".pdf")) {
                        return (
                          <div className="pdf-viewer-container">
                            <div className="pdf-wrapper">
                              <Worker
                                workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
                              >
                                <Viewer
                                  fileUrl={fileUrl}
                                  plugins={[defaultLayoutPluginInstance]}
                                  renderError={(error) => (
                                    <p className="text-center text-danger">
                                      Failed to load PDF: {error.message}.{" "}
                                      <a
                                        href={fileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Download
                                      </a>
                                    </p>
                                  )}
                                />
                              </Worker>
                            </div>
                          </div>
                        );
                      }
                      // DOCX
                      if (fileName.endsWith(".docx")) {
                        return (
                          <div
                            className="docx-content"
                            dangerouslySetInnerHTML={{
                              __html: file.content,
                            }}
                          />
                        );
                      }
                      // PPT/PPTX
                      if (fileName.endsWith(".ppt") || fileName.endsWith(".pptx")) {
                        // Google Docs Viewer embed
                        return (
                          <iframe
                            title="PowerPoint Preview"
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`}
                            style={{ width: "100%", height: "70vh", border: "none" }}
                            frameBorder="0"
                            allowFullScreen
                          />
                        );
                      }
                      // SVG
                      if (fileName.endsWith(".svg")) {
                        return (
                          <div className="svg-preview text-center">
                            <img
                              src={fileUrl}
                              alt={file.file_name}
                              style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
                              onError={() => toast.error("Failed to load SVG.")}
                            />
                          </div>
                        );
                      }
                      // Images
                      if ([".jpg", ".jpeg", ".png", ".webp"].some((ext) => fileName.endsWith(ext))) {
                        return (
                          <div className="image-preview text-center">
                            <img
                              src={fileUrl}
                              alt={file.file_name}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "80vh",
                                objectFit: "contain",
                              }}
                              onError={() => toast.error("Failed to load image.")}
                            />
                          </div>
                        );
                      }
                      // Text files
                      if ([".txt", ".csv", ".md", ".log"].some((ext) => fileName.endsWith(ext))) {
                        return (
                          <pre style={{ maxHeight: "60vh", overflowY: "auto", background: "#f8f9fa", padding: 16, borderRadius: 8 }}>
                            {textContent === null ? "Loading..." : textContent}
                          </pre>
                        );
                      }
                      // Fallback
                      return (
                        <div className="text-center">
                          <p>Preview not available for this file type.</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="download-btn"
                          >
                            Download File
                          </a>
                        </div>
                      );
                    })()}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDocumentModal(false)}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <ShareDocumentModal
                  show={showSherModal}
                  onHide={() => setShowSherModal(false)}
                  selectedFiles={selectedFiles.map(id => fetchedFiles.find(file => file.id === id)).filter(Boolean)}
                  userId={selectedUserId}
                />

                <MyFilesMetadata
                  show={showMetadataModal}
                  onHide={() => {
                    setShowMetadataModal(false);
                    setSelectedMetadata(null);
                  }}
                  metadata={selectedMetadata}
                />

                <ReminderModal
                  show={showReminderModal}
                  onHide={() => {
                    setShowReminderModal(false);
                    fetchFiles(); // Refresh file list after reminder modal closes
                  }}
                  file={selectedReminderFile}
                  userId={selectedUserId}
                  setReminderStatus={(fileId, status, reminderData) => {
                    setReminderStatus((prev) => ({ ...prev, [fileId]: status }));
                    setFiles((prevFiles) =>
                      prevFiles.map((file) =>
                        file.id === fileId
                          ? { ...file, reminder: status ? reminderData : null, has_reminder: status }
                          : file
                      )
                    );
                    setSelectedReminderFile((prev) =>
                      prev && prev.id === fileId
                        ? { ...prev, reminder: status ? reminderData : null, has_reminder: status }
                        : prev
                    );
                  }}
                />
              </div>
            </>
          ) : (
            <div>
              <MyFilesFolder
                userId={selectedUserId}
                onReminderUpdate={fetchFiles}
                files={files}
                setFiles={setFiles}
                reminderStatus={reminderStatus}
                setReminderStatus={setReminderStatus}
              />
            </div>
          )}
        </div>
      </section>

    </>
  );
};

export default MyFiles;